// FTEDN Team — Sentry client-side error tracking
import * as Sentry from '@sentry/react';

let initialized = false;

export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn || initialized) return;

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE || 'development',
    release: import.meta.env.VITE_GIT_SHA || 'team-dev',
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
    replaysSessionSampleRate: 0.01,
    replaysOnErrorSampleRate: 1.0,

    beforeSend(event) {
      if (event.exception?.values?.some(v => v.value?.includes('401'))) return null;
      if (event.exception?.values?.some(v => v.value?.includes('AbortError'))) return null;
      return event;
    },

    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
  });

  initialized = true;
  console.log('✅ Sentry initialized (team-app)');
}

export function captureError(error: Error, context?: Record<string, string>) {
  if (context) Sentry.setContext('custom', context);
  Sentry.captureException(error);
}

export function setSentryUser(user: { id: string; email?: string | null; displayName?: string }) {
  Sentry.setUser({ id: user.id, email: user.email ?? undefined, username: user.displayName });
}

export function clearSentryUser() {
  Sentry.setUser(null);
}

export const SentryErrorBoundary = Sentry.ErrorBoundary;
